import React, { useState } from 'react';
import { motion } from 'framer-motion';

const ServicesFAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "Can this service help reduce my Amazon account-related stress?",
      answer: "Absolutely. We handle every aspect of account management, freeing you to focus on strategy and growth without the stress of day-to-day issues."
    },
    {
      question: "How do you handle policy violations or account suspensions?",
      answer: "Our team has extensive experience with Amazon's policies, and we work quickly to address and resolve issues, including appealing suspensions."
    },
    {
      question: "Do I need a separate account manager for different Amazon regions?",
      answer: "No. Our unified account management service can manage multiple regions from a single Amazon Seller Central account, keeping everything streamlined."
    },
    {
      question: "Is it cost-effective to outsource account management compared to hiring in-house?",
      answer: "Outsourcing to us means leveraging a team of experienced professionals at a fraction of the cost of an in-house hire, providing better results for your budget."
    },
    {
      question: "How do I Create an Amazon Seller Account?",
      answer: "Visit the 'Seller Central' on Amazon to explore your business model, fulfillment method, and product category. An Amazon account manager can guide you, manage your setup, optimize listings, and choose the right tools to boost your sales."
    },
    {
      question: "Is Selling on Amazon Profitable? How Hard it is to Sale on Amazon?",
      answer: "Selling on Amazon, the world's largest eCommerce platform, offers great growth opportunities. With a strategic approach, professional account management, and consistent quality in inventory, shipping, and service, you can overcome competition and boost sales effectively."
    },
    {
      question: "What is Amazon Business Advisory (ABA)?",
      answer: "Amazon Business Advisory can be termed as Amazon account paid management service that provides consulting assistance to sellers with business intelligence inputs, strategic insights, and techniques to enhance their sales and revenue."
    },
    {
      question: "Who is an Amazon Account Manager?",
      answer: "An amazon account manager is a professional who is responsible for handling all tasks related to selling on the Amazon marketplace."
    },
    {
      question: "What is FBM and FBA?",
      answer: "That are 2 models of selling on Amazon, FBA: Fulfilment by Amazon n this sale model, Amazon handles the entire responsibility of logistics including packaging, product shipping, returns, and customer support and MFN: Merchant Fulfilled Network where the seller handle whole thing by them self."
    },
    {
      question: "What Strategies You Use for Amazon Account Management?",
      answer: "We implement competitor analysis, make use of user intent and the most suitable keywords, optimize each product category comprehensively, create rich, target-keyword-based product information, and apply innovative tactics specific to the buyers you are targeting."
    },
    {
      question: "What are the different selling plans on Amazon?",
      answer: "Amazon offers two main selling plans: Individual and Professional. The Individual plan has lower fees but has limitations, while the Professional plan offers more features and lower per-item fees, making it suitable for high-volume sellers."
    },
    {
      question: "How do I optimize my Amazon product listings for better search visibility?",
      answer: "Use relevant high search volume keywords, high quality product images, competitive price and add A+ Content to your listing with SEO friendly product description."
    },
    {
      question: "How do I run successful Amazon PPC campaigns?",
      answer: "Target relevant keywords with high search volume and low competition, adjust your bids, use high quality images and monitor campaign performance closely and make adjustments as needed."
    },
    {
      question: "What are some common reasons for Amazon account suspensions?",
      answer: "Policy violation, seller performance issue and customer services problems are the common reasons for account suspensions."
    },
    {
      question: "How do I choose the right products to sell on Amazon?",
      answer: "Consider factors like high demand, low competition, profitability, and your own interests and expertise. Research popular product categories and identify niche opportunities. Look for products with a strong potential for high-margin sales."
    },
    {
      question: "What are the key factors that influence Amazon product rankings?",
      answer: "Relevance, sales velocity, customer reviews, fulfilment method and pricing competitiveness"
    },
    {
      question: "What are the benefits of using Amazon Brand Registry?",
      answer: "Helps protect your brand from unauthorized sellers and counterfeiters, allows you to create and manage your brand store on Amazon and Sponsored brand and other advertising options."
    },
    {
      question: "What is the importance of customer feedback and how can I manage it effectively?",
      answer: "Customer feedback provides valuable insights into customer satisfaction and areas for improvement."
    },
    {
      question: "How can I reduce my Amazon FBA fees?",
      answer: "Optimize your product packaging and dimensions, use FBA Small and Light for eligible products."
    },
    {
      question: "What are the benefits of using Amazon A+ Content?",
      answer: "Allows you to showcase your brand and products more effectively."
    },
    {
      question: "What are some common challenges faced by Amazon sellers in 2025?",
      answer: "High competition, constant algorithm changes, managing inventory and fulfilment, staying compliant with Amazon policies, dealing with negative customer feedback, price wars and competition from other sellers, navigating the complexities of Amazon's advertising platforms."
    },
    {
      question: "What are some tips for optimizing my Amazon product listings for voice search?",
      answer: "Use long-tail keywords and conversational language in your product titles and descriptions, optimize your product titles for voice search queries."
    },
    {
      question: "How can I improve my Amazon product descriptions for better search visibility?",
      answer: "Use relevant keywords in your product title, description, and backend search terms, write compelling and informative product descriptions."
    },
    {
      question: "What is Amazon Global Selling and how it is work?",
      answer: "Amazon Global Selling allows businesses to sell their products on multiple Amazon marketplaces worldwide, expanding their reach to millions of new customers, it helps businesses sell their products on Amazon in countries other than their own."
    },
    {
      question: "How to reduce return on amazon?",
      answer: "Use accurate product descriptions, engaging visuals, and clear return policies to build trust. Ensure quality control, efficient fulfillment, and excellent customer service for a seamless shopping experience."
    }
  ];

  return (
    <section className="py-20 relative overflow-hidden">
      <div className="container mx-auto px-4 relative">
        {/* Header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="inline-block mb-4"
          >
            <span className="bg-primary/10 backdrop-blur-sm text-primary px-4 py-2 rounded-full text-sm font-medium border border-primary/20">
              FAQ
            </span>
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-3xl md:text-5xl font-bold text-white mb-6"
          >
            Frequently Asked<br />Questions
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="text-lg text-gray-400"
          >
            Find answers to common questions about our Amazon services
            and how we can help your business grow.
          </motion.p>
        </div>

        {/* FAQ List */}
        <div className="max-w-3xl mx-auto">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="mb-4"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full text-left p-6 rounded-2xl bg-gray-900/40 backdrop-blur-lg ring-1 ring-white/10 hover:ring-primary/20 transition-all"
              >
                <div className="flex justify-between items-center">
                  <h3 className="text-lg font-medium text-white">{faq.question}</h3>
                  <svg
                    className={`w-5 h-5 text-primary transition-transform ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
                {openIndex === index && (
                  <p className="mt-4 text-gray-400">{faq.answer}</p>
                )}
              </button>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesFAQ;
